import {
  ArticlesIndexPage,
  getStaticPropsForArticleIndexPage,
} from '@marketing-sites/blog-components/components/ArticleIndexPage'

export const getStaticProps = getStaticPropsForArticleIndexPage

export default ArticlesIndexPage
